import React from 'react';
import { Platform } from 'react-native';
import { useFocusEffect } from '@react-navigation/native';
import AppContext from 'contexts/AppContext';
import OrderContext from 'contexts/OrderContext';
import useChangeShoppingCart from 'hooks/useChangeShoppingCart';
import useChangeOrder from 'hooks/useChangeOrder';
import useChangePayment from 'hooks/useChangePayment';
import PaymentSitefScreenProps from 'types/screens/PaymentSitefScreenProps';
import { getSitefPaymentByNit } from 'services/paymentsService';
import { sitefGetUrl } from 'services/sitefServices';

export default ({ navigation, route }: PaymentSitefScreenProps): JSX.Element => {
  const { currentVenue, setCheckedForDifferentVenueCode } = React.useContext(AppContext);
  const { currentShoppingCart, currentOrder, resultPayment, setResultPayment, selectedPaymentConfig } =
    React.useContext(OrderContext);
  const { storeCurrentShoppingCart } = useChangeShoppingCart();
  const { storeCurrentOrder, deleteCurrentOrder } = useChangeOrder();
  const { changeResultPayment } = useChangePayment();

  const openForm = async () => {
    const sitefConfig = selectedPaymentConfig?.sitefConfig;

    if (
      !currentShoppingCart ||
      !currentShoppingCart.processed ||
      currentShoppingCart.paid ||
      !currentOrder ||
      !sitefConfig
    ) {
      if (currentShoppingCart?.paid) {
        await deleteCurrentOrder();
      }
      setTimeout(() => {
        navigation.reset({
          index: 0,
          routes: [{ name: 'HomeScreen' }],
        });
      }, 500);
      return;
    }
    await storeCurrentShoppingCart(currentShoppingCart);
    await storeCurrentOrder(currentOrder);

    let amount = '';
    if (currentOrder.totalAmount) {
      const parts = currentOrder.totalAmount.toString().split('.');
      const base = parts[0];
      let decimal = parts[1];
      if (!decimal) decimal = '00';
      else decimal = decimal.padEnd(2, '0');
      amount = `${base}${decimal}`;
    }

    const url = await sitefGetUrl(sitefConfig.id, amount, currentOrder.id, window.location.pathname);

    if (url) {
      window.location.replace(url);
    } else {
      navigation.reset({
        index: 1,
        routes: [
          { name: 'HomeScreen' },
          {
            name: 'ShoppingCartScreen',
            params:
              Platform.OS === 'web'
                ? {
                    venueCode: currentVenue?.code,
                    commerceCode: currentShoppingCart.commerce.code,
                  }
                : undefined,
          },
        ],
      });
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      if (route.params?.nit) {
        // Al volver de Sitef consultamos el pago por NIT. La orden se actualiza
        // por webhook (POST /api/sitef/webhook) cuando Sitef confirma con status "CON".
        // Si el webhook todavía no llegó, getByNit puede devolver null.
        getSitefPaymentByNit(route.params.nit).then((resultPayment) => {
          if (resultPayment) {
            setCheckedForDifferentVenueCode(true);
            setResultPayment({
              success: resultPayment.status === 'CON',
              response: resultPayment.message,
            });
          }
        });
      } else {
        openForm();
      }
      return () => {
        setResultPayment(null);
      };
    }, []),
  );

  React.useEffect(() => {
    if (resultPayment) changeResultPayment(resultPayment, false, route.params?.venueCode);
  }, [resultPayment]);

  return <></>;
};
